import React from "react";
import { ExampleSolutionInput } from "../../services/rubricAdminService";
import ArtifactUploader from "./ArtifactUploader";

interface Props {
  rubricId: string;
  getToken: () => string | undefined;
  value: ExampleSolutionInput;
  onChange: (next: ExampleSolutionInput) => void;
}

const SolutionExampleEditor: React.FC<Props> = ({ rubricId, getToken, value, onChange }) => (
  <div className="border border-outline-variant/30 rounded-md p-2">
    <label className="form-label text-xs">Example answer</label>
    <textarea
      className="form-control h-20 text-sm"
      value={value.answer ?? ""}
      onChange={(e) => onChange({ ...value, answer: e.target.value })}
    />
    <label className="form-label text-xs mt-2">Artifacts</label>
    <ArtifactUploader
      rubricId={rubricId}
      getToken={getToken}
      artifacts={value.artifacts ?? []}
      onChange={(artifacts) => onChange({ ...value, artifacts })}
    />
  </div>
);

export default SolutionExampleEditor;
